import React from 'react';
import { Link } from 'react-router-dom';
import './InfoPage.css';

function Host() {
  return (
    <div className="info-page">
      <div className="info-container">
        <h1>Torne-se um Anfitrião Nukki</h1>

        <section className="info-section">
          <h2>Compartilhe seu espaço, ganhe renda extra</h2>
          <p>Junte-se a milhares de anfitriões que estão ganhando dinheiro compartilhando suas casas no Nukki. Seja você com um quarto extra, casa de férias ou propriedade única, você pode transformar seu espaço em uma fonte de renda.</p>
        </section>

        <section className="info-section">
          <h3>Por que hospedar no Nukki?</h3>
          <div className="feature-grid">
            <div className="feature-box">
              <h4>Ganhe Renda Extra</h4>
              <p>Defina seus próprios preços e ganhe dinheiro no seu horário. Muitos anfitriões ganham o suficiente para cobrir sua hipoteca ou aluguel.</p>
            </div>
            <div className="feature-box">
              <h4>Proteção ao Anfitrião</h4>
              <p>Cada reserva inclui proteção contra danos ao anfitrião de até R$ 5.000.000 para danos à propriedade e cobertura de responsabilidade.</p>
            </div>
            <div className="feature-box">
              <h4>Conheça Pessoas de Todo o Mundo</h4>
              <p>Receba hóspedes de diferentes culturas e origens, criando conexões significativas.</p>
            </div>
            <div className="feature-box">
              <h4>Suporte Completo</h4>
              <p>Obtenha suporte ao cliente 24/7, recursos educacionais e uma comunidade de anfitriões companheiros para ajudá-lo a ter sucesso.</p>
            </div>
            <div className="feature-box">
              <h4>Hospedagem Flexível</h4>
              <p>Você está no controle. Hospede em tempo integral ou parcial, defina sua própria disponibilidade e escolha seus hóspedes.</p>
            </div>
            <div className="feature-box">
              <h4>Fácil de Começar</h4>
              <p>Crie seu anúncio em minutos com nosso processo simples passo a passo. Não é necessária experiência em hospedagem.</p>
            </div>
          </div>
        </section>

        <section className="info-section">
          <h3>Como Funciona</h3>
          <ol>
            <li><strong>Crie Seu Anúncio</strong> - Adicione fotos, escreva uma descrição e defina seus preços</li>
            <li><strong>Defina Sua Disponibilidade</strong> - Escolha quando seu espaço está disponível e bloqueie tempo pessoal</li>
            <li><strong>Aceite Reservas</strong> - Analise solicitações de hóspedes e aprove as que funcionam para você</li>
            <li><strong>Receba os Hóspedes</strong> - Proporcione uma ótima experiência e ganhe avaliações positivas</li>
            <li><strong>Receba o Pagamento</strong> - Receba o pagamento 24 horas após o check-in do hóspede</li>
          </ol>
        </section>

        <section className="info-section">
          <h3>O Que Você Pode Hospedar?</h3>
          <div className="feature-grid">
            <div className="feature-box">
              <h4>Casa Inteira</h4>
              <p>Casas de férias, apartamentos ou sua residência principal enquanto você estiver fora</p>
            </div>
            <div className="feature-box">
              <h4>Quarto Privado</h4>
              <p>Um quarto em sua casa com espaços comuns compartilhados</p>
            </div>
            <div className="feature-box">
              <h4>Quarto Compartilhado</h4>
              <p>Um quarto ou espaço comum compartilhado com outros</p>
            </div>
            <div className="feature-box">
              <h4>Espaços Únicos</h4>
              <p>Casas na árvore, barcos, casas minúsculas e outras acomodações criativas</p>
            </div>
          </div>
        </section>

        <section className="info-section">
          <h3>Dicas de Sucesso dos Melhores Anfitriões</h3>
          <ul>
            <li>Tire fotos de alta qualidade que mostrem seu espaço</li>
            <li>Escreva descrições detalhadas destacando características únicas</li>
            <li>Responda rapidamente às consultas dos hóspedes (dentro de 24 horas)</li>
            <li>Forneça instruções claras de check-in</li>
            <li>Mantenha seu calendário atualizado</li>
            <li>Mantenha limpeza e excelente hospitalidade</li>
            <li>Adicione toques especiais como presentes de boas-vindas ou recomendações locais</li>
          </ul>
        </section>

        <section className="info-section">
          <h3>Taxas de Hospedagem</h3>
          <p>O Nukki cobra uma taxa de serviço de aproximadamente 3% por reserva. Isso cobre o custo de funcionamento da plataforma, suporte 24/7 e processamento seguro de pagamentos. Você define seu preço e mostraremos o valor que você receberá após as taxas.</p>
        </section>

        <div className="cta-section">
          <h3>Pronto para Começar a Hospedar?</h3>
          <p>Junte-se à nossa comunidade de anfitriões e comece a ganhar hoje</p>
          <Link to="/create-property" className="btn-white">Criar Seu Anúncio</Link>
        </div>
      </div>
    </div>
  );
}

export default Host;
